import {
  AccountStatus,
  AirbnbQualityStandardState,
  BookingStatus,
  GuestReadinessStatus,
  ListingStatus,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'
import {
  BadgeColors,
  BadgeColorsProps,
  mainColors,
  riskChannelsColors,
  semanticColors,
} from '@avantstay/backoffice-core'

import { AuditPaymentStatus } from '../types/paymentAudit.types'

export const colorsByBookingStatusType: Record<BookingStatus, BadgeColorsProps> = {
  [BookingStatus.booked]: BadgeColors.channelWebsite,
  [BookingStatus.checkedOut]: BadgeColors.success,
  [BookingStatus.checkedIn]: BadgeColors.statusCheckedIn,
  [BookingStatus.requested]: BadgeColors.neutral,
  [BookingStatus.cancelled]: BadgeColors.failure,
  [BookingStatus.noShow]: BadgeColors.failure,
  [BookingStatus.modified]: BadgeColors.warning,
  [BookingStatus.quoted]: BadgeColors.neutral,
}

export const colorsByPaymentAuditStatusType = {
  [AuditPaymentStatus.canceled]: BadgeColors.failure,
  [AuditPaymentStatus.complete]: BadgeColors.success,
  [AuditPaymentStatus.followUp]: BadgeColors.warning,
  [AuditPaymentStatus.toDo]: BadgeColors.warning,
  [AuditPaymentStatus.unassigned]: BadgeColors.neutral,
}

export const colorByTripIssuesStatus: Record<string, string> = {
  [AirbnbQualityStandardState.good]: semanticColors.successMedium,
  [AirbnbQualityStandardState.educate]: semanticColors.warningLight,
  [AirbnbQualityStandardState.warn]: semanticColors.warningDark,
  [AirbnbQualityStandardState.suspend]: semanticColors.failureLight,
  [AirbnbQualityStandardState.probation]: semanticColors.failureMedium,
  [AirbnbQualityStandardState.additionalWarn]: semanticColors.failureDark,
  [AirbnbQualityStandardState.pendingRemoval]: riskChannelsColors.riskVeryHighDark,
  [AirbnbQualityStandardState.removed]: mainColors.black,
}

export const badgeColorByListingFlag: Record<string, BadgeColorsProps> = {
  [AirbnbQualityStandardState.good]: BadgeColors.success,
  [AirbnbQualityStandardState.educate]: BadgeColors.warning,
  [AirbnbQualityStandardState.warn]: BadgeColors.listingWarn,
  [AirbnbQualityStandardState.suspend]: BadgeColors.failure,
  [AirbnbQualityStandardState.probation]: BadgeColors.listingProbation,
  [AirbnbQualityStandardState.additionalWarn]: BadgeColors.listingAdditionalWarn,
  [AirbnbQualityStandardState.pendingRemoval]: BadgeColors.listingPendingRemoval,
  [AirbnbQualityStandardState.removed]: BadgeColors.listingRemoved,
}

export const colorByGuestReadinessStatus: Record<string, string> = {
  [GuestReadinessStatus.onboarding]: mainColors.accentMedium,
  [GuestReadinessStatus.onboarded]: semanticColors.successMedium,
  [GuestReadinessStatus.offboarding]: semanticColors.failureLight,
  [GuestReadinessStatus.offboarded]: semanticColors.failureMedium,
}

export const colorByAccountStatus: Record<string, string> = {
  [AccountStatus.active]: semanticColors.successMedium,
  [AccountStatus.inactive]: semanticColors.warningDark,
  [AccountStatus.terminated]: semanticColors.failureMedium,
}

export const colorByListingStatus: Record<string, string> = {
  [ListingStatus.listed]: semanticColors.successMedium,
  [ListingStatus.earlyListed]: mainColors.accentMedium,
  [ListingStatus.preListed]: semanticColors.warningDark,
  [ListingStatus.unlisted]: semanticColors.failureMedium,
}
